import { Badge } from '@/components/ui/badge'
import { trialStatusMeta } from '@/lib/customer-format'
import type { TrialStatus } from '@/lib/customer-types'

/** Trial/plan state pill — "Trial · 12d left", "Trial expired", or "Paying". */
export function TrialStatusBadge({
  status,
  daysRemaining,
}: {
  status: TrialStatus
  daysRemaining: number | null
}) {
  const { label, tone } = trialStatusMeta(status, daysRemaining)
  return <Badge variant={tone}>{label}</Badge>
}
